export default __webpack_public_path__ + "static/media/react_logo.cd867972.png";